import request from '@utils/fetch'
// 添加课程
export function addInstall(data) {
  return request({
    url: '/installManage/addInstall',
    method: 'post',
    data
  })
}
// 查询课程
export function selectInstallDetail() {
  return request({
    url: '/installManage/selectInstallDetail',
    method: 'get'
  })
}
